export class Clocks {
    id: number;
    userId: number;
    type: 'IN' | 'OUT';
    createdAt: Date;

    constructor(id: number, userId: number, type: 'IN' | 'OUT', createdAt: Date) {
        this.id = id;
        this.userId = userId;
        this.type = type;
        this.createdAt = createdAt;
    }
}